/* eslint-disable no-unused-vars */
/* eslint-disable quotes */
/* 分开之后得改路由，写全名，要不报错 */
import {
	formatDate
} from '../common/filters.js'
import {
	isvalidStem,
	isvalidCompletion,
	isvalidOption,
	isvalidBatchOption,
	isvalidPass,
	isvalidPhone,
	isvalidUsername
} from '../common/validate.js'
import store from '@/store/store'
// 试题拖拽
// import Sortable from 'sortablejs'
export default {
	name: '/manage/main.lecturer_paper',
	filters: {
		formatDate(time) {
			var date = new Date(time)
			// console.log(date)
			return formatDate(date, 'yyyy-MM-dd')
		}
	},
	/* 页面刷新  方法中可以直接调用this.reload() */
	// inject: ['reload'],
	data: function () {
		/* 试卷自定义校验 */
		var validatePaperName = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请输入试卷名'))
			} else {
				callback()
			}
		}
		var validateTotalScore = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请输入总分'))
			}
			setTimeout(() => {
				if (!Number.isInteger(value)) {
					callback(new Error('请输入数字'))
				} else if (value > 999) {
					callback(new Error('最大不能超过999'))
				} else {
					callback()
				}
			})
		}
		var validatePassScore = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请输入及格分'))
			}
			setTimeout(() => {
				if (!Number.isInteger(value)) {
					callback(new Error('请输入数字'))
				} else if (this.paperForm.totalScore == '' || this.paperForm.totalScore == undefined) {
					callback(new Error('请先输入总分'))
				} else if (value >= this.paperForm.totalScore) {
					callback(new Error('不能大于或等于总分'))
				} else {
					callback()
				}
			})
		}

		/* 题目自定义校验 */
		var validatePassStem = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请输入试题'))
			} else if (this.handleQues.questionType == 3) {
				if (isvalidStem(value)) {
					callback(new Error("录入题目示例:以_相伴一生"))
				} else if (!isvalidCompletion(value)) {
					callback(new Error("录入题目示例:以_相伴一生"))
				} else if (value == '_') {
					callback(new Error("录入题目示例:以_相伴一生"))
				} else {
					callback()
				}
			} else {
				callback()
			}
		}
		var validatePassOption = (rule, value, callback) => {
			if (this.handleQues.questionType == 1 || this.handleQues.questionType == 4) {
				if (!value) {
					return callback(new Error('请输入选项'))
				} else {
					callback()
				}
			} else {
				callback()
			}
		}
		var validatePassAnswer = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请输入正确答案'))
			}
			if (this.handleQues.questionType == 1) {
				if (!isvalidOption(value)) {
					callback(new Error("只可填写其中1个选项,如:B"))
				} else {
					callback()
				}
			} else if (this.handleQues.questionType == 4) {
				if (!isvalidBatchOption(value)) {
					callback(new Error("请按顺序填写格式,如:ABD"))
				} else if (value.length < 2) {
					callback(new Error("至少输入两个选项"))
				} else {
					callback()
				}
			} else {
				callback()
			}
		}
		var validatePassFraction = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请输入题目分'))
			}
			setTimeout(() => {
				if (!Number.isInteger(value)) {
					callback(new Error('请输入数字'))
				} else if (value > 10) {
					callback(new Error('输入不能大于10'))
				} else {
					callback()
				}
			})
		}

		return {
		// 试题拖拽
		// 	col: [{
		// 		label: '试题',
		// 		prop: 'stem'
		// 	},
		// 	{
		// 		label: '题型',
		// 		prop: 'questionType'
		// 	},
		// 	{
		// 		label: '类型',
		// 		prop: 'questionClass'
		// 	},
		// 	{
		// 		label: '试题分',
		// 		prop: 'questionFraction'
		// 	},
		// 	{
		// 		label: '出题人',
		// 		prop: 'sidno'
		// 	},
		// 	{
		// 		label: '创建时间',
		// 		prop: 'createTime'
		// 	},
		// ],
		// dropCol: [{
		// 		label: '试题',
		// 		prop: 'stem'
		// 	},
		// 	{
		// 		label: '题型',
		// 		prop: 'questionType'
		// 	},
		// 	{
		// 		label: '类型',
		// 		prop: 'questionClass'
		// 	},
		// 	{
		// 		label: '试题分',
		// 		prop: 'questionFraction'
		// 	},
		// 	{
		// 		label: '出题人',
		// 		prop: 'sidno'
		// 	},
		// 	{
		// 		label: '创建时间',
		// 		prop: 'createTime'
		// 	},
		// ],
		// tableData: [],
			paper: {
				id: '',
				paperName: '',
				paperType: '',
				totalScore: '',
				passScore: '',
				quesNum: 0,
				createUser: '',
				sidno: '',
				// tvName: '',

				pageNum: 1,
				size: 10,
				total: 0,
				rows: []
			},
			multipleSelection: [],

			/* 用户session */
			sysUser: store.getters.staffId,
			/* 通用输入框宽度 */
			formLabelWidth: '150px',

			/* 新增试卷 */
			addDialogFormVisible: false,
			paperForm: {
				paperName: '',
				paperType: '',
				totalScore: '',
				passScore: '',
				createUser: '',
				state: ''
				/* ,
				        videoId: '' */
			},

			/* 随机抽题 */
			randomDialogFormVisible: false,
			randomForm: {
				paperName: '',
				paperType: '',
				totalScore: '',
				passScore: '',
				createUser: '',
				state: '',
				score1: 0,
				score5: 0,
				score10: 0
			},

			/* 编辑试卷 */
			updateDialogFormVisible: false,

			/* 关联视频 */
			/* video: [],
			videoState: '',
			timeout: null, */

			/* 添加试题 */
			epqPaperId: '',
			ePaperName: '',
			checkDialogFormVisible: false,
			checkForm: {
				id: '',
				stem: '',
				epqPaperId: '',
				sidno: '',
				questionType: '',
				questionClass: '',
				pageNum: 1,
				total: 0,
				size: 10,
				rows: [],
				paperId: '',
				paperName: ''
			},
			checkMultipleSelection: [],

			/* 指定一个key标识这一行的数据,保存分页时选中的选项 */
			getRowKeys(row) {
				return row.id
			},

			show: 0,

			/* 添加并保存在试卷 */
			checkAddDialogFormVisible: false,
			handleQues: {
				id: '',
				stem: '',
				answer: '',
				questionType: '',
				questionClass: '',
				questionFraction: '',
				topicMaker: '',
				state: '',
				/* 添加内的选项 */
				option: [{
					optionNum: '',
					content: ''
				}]
			},
			/* 在试卷内修改试题 */
			updateQuesDialogFormVisible: false,

			/* 获得分类名 */
			maintaintype: [],
			videoType: [],
			typeProps: {
				value: 'Id',
				label: 'Name',
				children: 'children',
				checkStrictly: true
			},

			/* 删除试题的对话框 */
			delQuesDialogFormVisible: false,
			delQuesTable: {
				id: '',
				stem: '',
				answer: '',
				questionType: '',
				questionClass: '',
				questionFraction: '',
				topicMaker: '',
				state: '',
				pageNum: 1,
				size: 10,
				total: 0,
				rows: [],
				paperId: '',
				paperName: ''
			},
			delQuesMultipleSelection: [],

			/* 派发页面 */
			distributeDialogFormVisible: false,
			distribute: {
				paperIdArr: [],
				paperName: '',
				staffId: '',
				state: ''
			},
			staffObj: {
				rows: [],
				userName: '',
				idNo: '',
				mobile: '',
				jmId: '',
				pageNo: 1,
				total: 0,
				size: 10
			},
			jobList: [], // 职务列表
			job: [], // 存放职务Id
			distributeMultipleSelection: [],
			/* 限制时间 */
			limitTimeHandDialogFormVisible: false,
			limitDate: '',

			datePicker: {
				disabledDate(time) {
					// console.log(time.getTime())
					// console.log(Date.now())
					if (Date.now() > time.getTime()) {
						return true
					}
					return false
				}
			},

			/* 派发记录 */
			distributeRecordHandDialogFormVisible: false,
			distributeRecordParameter: {
				ePaperName: '',
				sidno: '',
				rows: [],
				pageNo: 0,
				total: 0,
				size: 10
			},
			distributeRecordMultipleSelection: [],

			/* 关联视频 */
			videoHandDialogFormVisible: false,
			video: {
				pageNo: 0,
				total: 0,
				size: 10,
				rows: [],
				name: '',
				type: ''
			},
			videoMultipleSelection: [],

			/* 关联视频列表 */
			videoRecordHandDialogFormVisible: false,
			videoRecord: {
				pageNo: 0,
				total: 0,
				size: 10,
				name: '',
				sidno: '',
				paperName: '',
				rows: [],
			},
			videoRecordMultipleSelection: [],

			/* 主页面加载 */
			loading: true,
			/* 派发页面加载 */
			distributeLoading: true,
			/* 派发完成加载 */
			disSuccessLoading: false,
			/* 派发记录加载 */
			disRecordLoading: true,
			/* 视频dialog加载 */
			videoLoading: true,
			/* 视频关联记录dialog加载 */
			videoRecordLoading: true,

			/* 试卷表单验证 */
			rulesPaper: {
				paperName: [{
					required: true,
					validator: validatePaperName,
					trigger: 'blur',
				}],
				paperType: [{
					required: true,
					type: "string",
					message: '请选择类型',
					trigger: 'change',
					transform(value) {
						var base
						if (value) {
							// 在select中转换要加这个判断,因为select默认有一个空选项
							base = "" + value
						}
						return base
					}
				}],
				totalScore: [{
					required: true,
					validator: validateTotalScore,
					trigger: 'blur'
				}],
				passScore: [{
					required: true,
					validator: validatePassScore,
					trigger: 'blur'
				}]
			},

			/* 题目表单验证 */
			rulesQues: {
				stem: [{
					required: true,
					trigger: 'blur',
					validator: validatePassStem
				}],
				answer: [{
					required: true,
					trigger: 'blur',
					validator: validatePassAnswer
				}],
				questionFraction: [{
					required: true,
					trigger: 'blur',
					validator: validatePassFraction
				}],
				questionType: [{
					required: true,
					message: '请选择题型',
					trigger: 'change'
				}],
				questionClass: [{
					required: true,
					type: "string",
					message: '请选择类型',
					trigger: 'change',
					transform(value) {
						var base
						if (value) {
							// 在select中转换要加这个判断,因为select默认有一个空选项
							base = "" + value
						}
						return base
					}
				}]
			},
			rulesQuesOptions: [{
				required: true,
				validator: validatePassOption,
				trigger: 'blur'
			}]

		}
	},
	mounted() {
		this.selectPaperList()
		this.selectExamType()
		this.selectVideoType()
	},
	computed: {
		stemPlaceholder() {
			if (this.handleQues.questionType == 3) {
				return "录入题目示例:以_相伴一生"
			} else if (this.handleQues.questionType == 1 || this.handleQues.questionType == 4) {
				return "录入题目示例:以()相伴一生"
			}
		}
	},
	methods: {
		// 试题拖拽
		// rowDrop() {
		// 	const tbody = document.querySelector('.el-table__body-wrapper tbody')
		// 	const _this = this
		// 	Sortable.create(tbody, {
		// 		onEnd({
		// 			newIndex,
		// 			oldIndex
		// 		}) {
		// 			const currRow = _this.tableData.splice(oldIndex, 1)[0]
		// 			_this.tableData.splice(newIndex, 0, currRow)
		// 			// console.log(_this.delQuesTable.pageNum)
		// 			// console.log(_this.delQuesTable.size)
		// 			// console.log(currRow)
		// 			// console.log(oldIndex)
		// 			var pageIndex = (_this.delQuesTable.pageNum - 1) * _this.delQuesTable.size + newIndex
		// 			console.log(pageIndex)
		// 		}
		// 	})
		// },
		/* 查询考试分类 */
		selectExamType() {
			this.$get('Exam_Type/selectAllList')
				.then(response => {
					var typeList = response.list
					/* 2020年6月8日：递归、将children.length=0 的赋值 null */
					for (let i = 0; i < typeList.length; i++) {
						/* 2020年6月8日：三层分类的话必须先将第三层赋值为null。 */
						if (typeList[i].children.length != 0) {
							for (let j = 0; j < typeList[i].children.length; j++) {
								if (typeList[i].children[j].children < 1) {
									typeList[i].children[j].children = undefined
								}
							}
						} else {
							typeList[i].children = null
						}
						// console.log(typeList[i].children);
					}
					this.maintaintype = typeList
					// console.log(this.maintaintype);
					// console.log(response);
				})
				.catch(error => {
					this.$message.error(error)
					console.log(error)
				})
		},
		/* 查询视频分类 */
		selectVideoType() {
			this.$postJson('trainingVideoType/select')
				.then(res => {
					var typeList = res.list
					/* 2020年6月8日：递归、将children.length=0 的赋值 null */
					for (let i = 0; i < typeList.length; i++) {
						/* 2020年6月8日：三层分类的话必须先将第三层赋值为null。 */
						if (typeList[i].children.length != 0) {
							for (let j = 0; j < typeList[i].children.length; j++) {
								if (typeList[i].children[j].children < 1) {
									typeList[i].children[j].children = undefined
								}
							}
						} else {
							typeList[i].children = null
						}
					}
					this.videoType = typeList
					// console.log(typeList,this.videoType);
				})
				.catch(err => {
					this.$message.error(err)
					console.log(err)
				})
		},

		/* 查询主页面试卷表格 */
		selectPaperList() {
			/* let size = this.size;var param = {paperName: this.paperName,paperType: this.paperType,sidno: this.sidno,state: 1};this.$fenye('zhongljBack/mapi/Exam_Paper/selectcount', 'zhongljBack/mapi/Exam_Paper/select', param,pageNum, size, result => {this.paper = result;this.pageNum = result.pageNum;// console.log(this.pageNum)}) */
			var type = ''
			if (this.paper.paperType != '' && this.paper.paperType != null && this.paper.paperType != undefined) {
				type = this.paper.paperType[this.paper.paperType.length - 1]
			}

			// var params = new URLSearchParams()
			// params.append('paperName', this.paper.paperName)
			// params.append('paperType', type)
			// params.append('sidno', this.paper.sidno)
			// params.append('state', 1)
			// params.append('pageNo', this.paper.pageNum)
			// params.append('pageSize', this.paper.size)
			let params = {
				'paperName': this.paper.paperName,
				'paperType': type,
				'sidno': this.paper.sidno,
				'state': 1,
				'pageNo': this.paper.pageNum,
				'pageSize': this.paper.size
			}

			this.$post('LecturerPaper/select', params)
				.then(response => {
					// console.log(response)
					this.paper.rows = response.list.rows
					this.paper.total = response.list.total
					this.loading = false
				})
				.catch(error => {
					this.$message.error(error)
					console.log(error)
				})
		},
		handleSelectionChange(val) {
			this.multipleSelection = val
			// console.log(this.multipleSelection)
		},
		handleCurrentChange(val) {
			this.paper.pageNum = val
			this.selectPaperList()
		},
		handleSizeChange(val) {
			this.paper.size = val
			this.selectPaperList()
		},
		/* 批量删除试卷 */
		delBatch() {
			this.$confirm('即将删除已选试卷, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				const paperArr = []
				for (let i = 0; i < this.multipleSelection.length; i++) {
					paperArr[i] = this.multipleSelection[i].id
				}
				// console.log(paperArr)
				this.$postJson('LecturerPaper/delBatch', {
						idArr: paperArr
					})
					.then(response => {
						this.selectPaperList()
						this.$message({
							type: 'success',
							message: '删除成功!'
						})
					})
					.catch(error => {
						console.log(error)
						this.$message.error('删除失败！')
					})
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消删除'
				})
			})
		},

		/* 添加试题页面查询 */
		checkNoExists(epqPaperId, ePaperName, pageNum) {
			/* this.checkForm.stem = '';this.checkForm.questionType = '';this.checkForm.questionClass = '';this.checkForm.sidno = ''; */
			this.checkDialogFormVisible = true
			this.checkMultipleSelection = []
			this.checkForm.paperId = epqPaperId
			this.checkForm.paperName = ePaperName
			this.checkForm.pageNum = pageNum

			// var params = new URLSearchParams()
			// params.append('epqPaperId', this.checkForm.paperId)
			// params.append('state', 1)
			// params.append('isCheck', 1)
			// params.append('pageNo', this.checkForm.pageNum)
			// params.append('pageSize', this.checkForm.size)
			let params = {
				'epqPaperId': this.checkForm.paperId,
				'state': 1,
				'isCheck': 1,
				'pageNo': this.checkForm.pageNum,
				'pageSize': this.checkForm.size
			}

			this.$post('LecturerQuestion/selectAllNotOption', params)
				.then(response => {
					// console.log(response)
					this.checkForm.rows = response.list.rows
					this.checkForm.total = response.list.total
				})
				.catch(error => {
					this.$message.error(error)
					console.log(error)
				})
			// console.log(this.epqPaperId);/* var param = {stem: this.checkForm.stem,questionType: this.checkForm.questionType,questionClass: this.checkForm.questionClass,sidno: this.checkForm.sidno,epqPaperId: epqPaperId,state: 1};this.$fenye('zhongljBack/mapi/Exam_Question/selectcount', 'zhongljBack/mapi/Exam_Question/selectAllNotOption',param,pageNum, 5, result => {this.editTable = result;this.editTable.pageNum = result.pageNum;this.ePaperName = ePaperName}) */
			// console.log(this.editTable.pageNum)/* this.$post('zhongljBack/mapi/Exam_Question/paper', {epqPaperId: this.epqPaperId,state: 1}).then(response => {this.checkMultipleSelection = response.key;this.ePaperName = ePaperName// 分页时回显this.$nextTick(() => {if (this.editTable.key !== undefined && this.checkMultipleSelection !== undefined) {this.checkMultipleSelection.forEach((v, i) => {this.editTable.key.forEach((_v, _i) => {if (v.id === _v.id) {// true 保持选中this.$refs.checkMultipleTable.toggleRowSelection(_v, true);}})})}})}).catch(error => {console.log(error);}) */
		},
		checkHandleCurrentChange(val) {
			this.checkSelect(val)
		},
		checkHandleSizeChange(val) {
			this.checkForm.size = val
			this.checkSelect(1)
		},
		checkClear() {
			this.checkForm.stem = ''
			this.checkForm.questionType = ''
			this.checkForm.questionClass = ''
			this.checkForm.sidno = ''
		},
		/* 添加试题页面内新建试题 清空 */
		checkAdd() {
			this.checkAddDialogFormVisible = true
			this.handleQues.stem = ''
			this.handleQues.questionType = ''
			this.handleQues.questionClass = ''
			this.handleQues.sidno = ''
			this.handleQues.answer = ''
			this.handleQues.questionFraction = ''
			this.show = 0
			this.handleQues.option = [{
				optionNum: 'A'
			}, {
				optionNum: 'B'
			}, {
				optionNum: 'C'
			}, {
				optionNum: 'D'
			}]
		},
		/* 添加试题页面内查询 */
		checkSelect(pageNum) {
			/* let size = this.checkSize;var param = {stem: this.checkForm.stem,questionType: this.checkForm.questionType,questionClass: this.checkForm.questionClass,sidno: this.checkForm.sidno,state: 1,epqPaperId: this.epqPaperId};this.$fenye('zhongljBack/mapi/Exam_Question/selectcount', 'zhongljBack/mapi/Exam_Question/selectAllNotOption',param,pageNum, size, result => {this.editTable = result;this.editTable.pageNum = result.pageNum;this.$post('zhongljBack/mapi/Exam_Question/paper', {epqPaperId: this.epqPaperId,state: 1}).then(response => {this.checkMultipleSelection = response.key;}).catch(error => {console.log(error);})}) */
			var type = ''
			if (this.checkForm.questionClass != '' && this.checkForm.questionClass != null && this.checkForm.questionClass !=
				undefined) {
				type = this.checkForm.questionClass[this.checkForm.questionClass.length - 1]
			}
			let params = {
				'stem': this.checkForm.stem,
				'questionType': this.checkForm.questionType,
				'questionClass': type,
				'sidno': this.checkForm.sidno,
				'epqPaperId': this.checkForm.paperId,
				'state': 1,
				'isCheck': 1,
				'pageNo': this.checkForm.pageNum,
				'pageSize': this.checkForm.size
			}

			this.$post('LecturerQuestion/selectAllNotOption', params)
				.then(response => {
					// console.log(response)
					this.checkForm.rows = response.list.rows
					this.checkForm.total = response.list.total
				})
				.catch(error => {
					this.$message.error(error)
					console.log(error)
				})
		},
		addQuesIsShow() {
			let value = this.handleQues.questionType
			if (value == 1 || value == 4) {
				this.show = 1
			} else {
				this.show = 0
			}
		},
		/* 添加试题页面内新建试题 */
		checkAddQues(handleQues) {
			this.$refs.handleQues.validate((valid) => {
				if (valid) {
					if (handleQues.questionType == 1 || handleQues.questionType == 4) {
						this.handleQues.answer = handleQues.answer.toUpperCase()
					}
					this.$postJson('LecturerQuestion/add', {
							stem: this.handleQues.stem,
							answer: this.handleQues.answer,
							questionType: this.handleQues.questionType,
							questionClass: this.handleQues.questionClass,
							questionFraction: this.handleQues.questionFraction,
							topicMaker: this.sysUser,
							state: 1,
							option: this.handleQues.option
						})
						.then(response => {
							var question = []
							question[0] = response.key
							// console.log(question[0])
							this.$postJson('LecturerPaperQuestion/add', {
									paperId: this.epqPaperId,
									questionIds: question
								})
								.then(response => {
									this.checkAddDialogFormVisible = false
									this.checkSelect(1)
								})
								.catch(error => {
									this.$message.error(error)
									console.log(error)
								})
						})
						.catch(error => {
							this.$message.error(error)
							console.log(error)
						})
				}
			})
		},

		updateQuesIsShow() {
			let value = this.handleQues.questionType
			if (value == 1 || value == 4) {
				this.show = 1
				// console.log(this.show)
			} else {
				this.show = 0
			}
		},
		/* 查看试题页面内 更新试题 回显 */
		checkUpdate(row) {
			this.updateQuesDialogFormVisible = true
			let value = row.questionType
			var option = [{
				optionNum: 'A'
			}, {
				optionNum: "B"
			}, {
				optionNum: 'C'
			}, {
				optionNum: 'D'
			}]
			if (value == 1 || value == 4) {
				this.show = 1
			} else {
				this.show = 0
			}
			this.$postJson('LecturerQuestion/selectall', {
					id: row.id
				})
				.then(response => {
					this.handleQues = response.key[0]
					if (this.handleQues.option.length == 0) {
						this.handleQues.option = option
					}
				}).catch(error => {
					this.$message.error(error)
					console.log(error)
				})
			// this.handleQues = row;
		},
		/* 查看试题页面内 更新试题 */
		checkUpdateQues(handleQues) {
			this.$refs.handleQues.validate((valid) => {
				if (valid) {
					if (handleQues.questionType == 1 || handleQues.questionType == 4) {
						this.handleQues.answer = handleQues.answer.toUpperCase()
					}
					this.$postJson('LecturerQuestion/update', this.handleQues)
						.then(response => {
							this.updateQuesDialogFormVisible = false
							if (this.checkDialogFormVisible == true) {
								this.checkSelect(1)
							} else if (this.delQuesDialogFormVisible == true) {
								this.checkExists(this.epqPaperId, this.ePaperName, 1)
							}
						}).catch(error => {
							this.$message.error(error)
							console.log(error)
						})
				}
			})
		},
		checkHandleSelectionChange(val) {
			this.checkMultipleSelection = val
		},
		/* checkDelQuesBatch() {if (!confirm('确定要删除吗？')) {return;}const quesArr = []for (let i = 0; i < this.checkMultipleSelection.length; i++) {quesArr[i] = this.checkMultipleSelection[i].epqId}this.$post('zhongljBack/mapi/Exam_Paper_Question/delBatch', {idArr: quesArr}).then(response => {this.check(this.epqPaperId, 1)}).catch(error => {console.log(error);})}, */

		/* 添加或修改试题 */
		editQues() {
			const quesArr = []
			for (let i = 0; i < this.checkMultipleSelection.length; i++) {
				quesArr[i] = this.checkMultipleSelection[i].id
			}
			this.$postJson('LecturerPaperQuestion/add', {
					questionIds: quesArr,
					paperId: this.checkForm.paperId
				})
				.then(response => {
					this.checkDialogFormVisible = false
					this.selectPaperList()
					// this.reload();
				})
				.catch(error => {
					this.$message.error(error)
					console.log(error)
				})
		},

		/* 主页面内弹窗 */
		add() {
			this.addDialogFormVisible = true
			this.paperForm.paperName = ''
			this.paperForm.paperType = ''
			this.paperForm.totalScore = ''
			this.paperForm.passScore = ''
			// this.videoState = '';
		},
		/* 添加试卷 */
		addPaper(paperForm) {
			/* 2020年6月8日：分类转换 */
			if (this.paperForm.paperType != '' && this.paperForm.paperType != null && this.paperForm.paperType != undefined) {
				paperForm.paperType = this.paperForm.paperType[this.paperForm.paperType.length - 1]
			}
			// console.log(paperForm);
			this.$refs.paperForm.validate((valid) => {
				if (valid) {
					this.$postJson('LecturerPaper/add', {
							paperName: paperForm.paperName,
							paperType: paperForm.paperType,
							totalScore: 0,
							passScore: 0,
							createUser: this.sysUser,
							state: 1
							// ,videoId: this.paperForm.videoId
						})
						.then(response => {
							this.addDialogFormVisible = false
							this.selectPaperList()
						})
						.catch(error => {
							this.$message.error(error)
							console.log(error)
						})
				}
			})
		},
		/* 随机抽题模块 */
		random() {
			this.randomDialogFormVisible = true
			this.randomForm.paperName = ''
			this.randomForm.paperType = ''
			this.randomForm.score1 = 0
			this.randomForm.score5 = 0
			this.randomForm.score10 = 0
			// this.randomForm.score4 = 0;
			// this.randomForm.score5 = 0;
		},
		randomAdd(randomForm) {
			/* 2020年6月8日：分类转换 */
			if (this.randomForm.paperType != '' && this.randomForm.paperType != null && this.randomForm.paperType !=
				undefined) {
				randomForm.paperType = this.randomForm.paperType[this.randomForm.paperType.length - 1]
			}
			this.paper.pageNum = 1

			var scoreList = [{
				fraction: 1,
				quesCount: this.randomForm.score1
			}, {
				fraction: 5,
				quesCount: this.randomForm.score5
			}, {
				fraction: 10,
				quesCount: this.randomForm.score10
			}]

			this.$refs.randomForm.validate((valid) => {
				if (valid) {
					this.$postJson('LecturerPaper/addRandom', {
							paperName: randomForm.paperName,
							paperType: randomForm.paperType,
							totalScore: 0,
							passScore: 0,
							scoreList,
							createUser: this.sysUser,
						})
						.then(response => {
							this.randomDialogFormVisible = false
							this.addDialogFormVisible = false
							this.selectPaperList()
						})
						.catch(error => {
							this.$message.error(error)
							console.log(error)
						})
				}
			})
		},
		/* 更新试卷 */
		update(row) {
			// this.videoState = '';
			// var params = new URLSearchParams();
			// params.append('id', row.id);
			this.updateDialogFormVisible = true
			// this.paperForm.tvName = ''
			this.$postJson('LecturerPaper/selectid', {
					'id': row.id
				})
				.then(response => {
					this.paperForm = response.key
					// console.log(this.paperForm);
				}).catch(error => {
					this.$message.error(error)
					console.log(error)
				})
		},
		updatePaper(paperForm) {
			/* 2020年6月8日：分类转换 */
			// console.log(paperForm.paperType);
			if (Array.isArray(paperForm.paperType)) {
				paperForm.paperType = this.paperForm.paperType[this.paperForm.paperType.length - 1]
			}

			this.$refs.paperForm.validate((valid) => {
				if (valid) {
					this.$postJson('LecturerPaper/update', paperForm)
						.then(response => {
							this.updateDialogFormVisible = false
							this.selectPaperList()
							this.$message({
								type: 'success',
								message: '修改成功!'
							})
						})
						.catch(error => {
							console.log(error)
							this.$message.error('修改失败！')
						})
				}
			})
		},

		/* 查看试题的对话框 */
		checkExists(paperId, paperName, pageNum) {
			this.delQuesDialogFormVisible = true
			this.delQuesMultipleSelection = []
			/* var param = {epqPaperId: epqPaperId,ePaperName: ePaperName,state: 1}this.$fenye('zhongljBack/mapi/Exam_Question/selectpapercount', 'zhongljBack/mapi/Exam_Question/paper',param,pageNum, 5, result => {this.delQuesTable = result;this.ePaperName = ePaperName;this.epqPaperId = epqPaperId// console.log(result)}) */
			this.delQuesTable.paperId = paperId
			this.delQuesTable.paperName = paperName
			this.delQuesTable.pageNum = pageNum
			let params = {
				'epqPaperId': paperId,
				'state': 1,
				'pageNo': this.delQuesTable.pageNum,
				'pageSize': this.delQuesTable.size
			}

			this.$post('LecturerQuestion/paper', params)
				.then(response => {
					// console.log(response)
					this.delQuesTable.rows = response.list.rows
					// 试题拖拽
					// this.tableData = response.list.rows
					this.delQuesTable.total = response.list.total
					this.ePaperName = paperName
					// 试题拖拽
					// this.rowDrop()
				})
				.catch(error => {
					this.$message.error(error)
					console.log(error)
				})
		},

		/* 查看试题页面内   移除试题 */
		delQuesHandleSelectionChange(val) {
			this.delQuesMultipleSelection = val
		},
		delQuesHandleCurrentChange(val) {
			this.checkExists(this.delQuesTable.paperId, this.delQuesTable.paperName, val)
		},
		delQuesHandleSizeChange(val) {
			this.delQuesTable.size = val
			this.checkExists(this.delQuesTable.paperId, this.delQuesTable.paperName, 1)
		},
		delQuesByBatch() {
			this.$confirm('是否移除?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				const quesArr = []
				for (let i = 0; i < this.delQuesMultipleSelection.length; i++) {
					quesArr[i] = this.delQuesMultipleSelection[i].epqId
				}
				this.$postJson('LecturerPaperQuestion/delBatch', {
						paperId: this.delQuesTable.paperId,
						idArr: quesArr
					})
					.then(response => {
						this.delQuesDialogFormVisible = false
						this.$message({
							type: 'success',
							message: '移除成功!'
						})
						// this.reload();
						this.selectPaperList()
					})
					.catch(error => {
						console.log(error)
						this.$message.error('移除失败！')
					})
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消'
				})
			})
		},
		/* del(row) {if (!confirm('是否确定删除吗？')) {return;}this.$post('zhongljBack/mapi/Exam_Paper/update', {id: row.id,state: 0}).then(response => {this.fenye(this.pageNum);}).catch(error => {console.log(error);})}, */

		select() {
			this.paper.pageNum = 1
			this.selectPaperList()
		},
		clear() {
			this.paper.paperName = ''
			this.paper.paperType = ''
			this.paper.sidno = ''
		},

		/* 派发页面 */
		distributeStaff() {
			this.selectJobList()
			let totalScore = true
			for (let i in this.multipleSelection) {
				// console.log(this.multipleSelection);
				if (this.multipleSelection[i].totalScore == 0) {
					totalScore = false
				}
				/* else {
				          this.distribute.paperIdArr.push(this.multipleSelection[i].id)
				        } */
			}
			if (totalScore == false) {
				this.$message.error('请添加题目到已选试卷中，再进行派发。')
			} else {
				this.distributeDialogFormVisible = true

				let params = {
					'pageNo': this.staffObj.pageNo,
					'pageSize': this.staffObj.size
				}

				this.$post('LecturerStaff/select', params)
					.then(response => {
						this.distributeLoading = false
						this.staffObj.rows = response.list.rows
						this.staffObj.total = response.total
						this.staffObj.pageNo = response.list.page
						// console.log(response)
					})
					.catch(error => {
						this.$message.error(error)
						console.log(error)
					})
			}
		},
		selectJobList() {
			let loading = this.$loading()
			this.$get(`/getJobList?pageNo=1&pageSize=999`)
			.then(res => {
				loading.close()
				if (res && res.errCode === 0) {
					this.jobList = res.list
				}
			}, err => {
				loading.close()
				this.$message.error(err)
			})
		},
		distributeHandleSelectionChange(val) {
			this.distributeMultipleSelection = val
			// console.log(this.distributeMultipleSelection)
		},
		distributeHandleCurrentChange(val) {
			this.distributeStaff(this.id, this.ePaperName, val)
		},
		staffObjClear() {
			this.staffObj.userName = ''
			this.staffObj.idNo = ''
			this.job = []
		},
		distributeHandleSizeChange(val) {
			this.staffObj.size = val
			this.distributeStaff(this.id, this.ePaperName, 1)
		},
		staffObjSelect() {
			var params = {
				'userName': this.staffObj.userName,
				'idNo': this.staffObj.idNo,
				'jmId': this.job.toString(),
				'pageNo': 1,
				'pageSize': this.staffObj.size
			}
			this.$post('LecturerStaff/select', params)
				.then(response => {
					this.staffObj.rows = response.list.rows
					this.staffObj.pageNo = response.list.page
					this.staffObj.total = response.total
					// console.log(response)
				})
				.catch(error => {
					this.$message.error(error)
					console.log(error)
				})
			// this.distributeStaff(this.id, this.ePaperName, this.staffObj.pageNo);
		},
		distributePaper() {
			const staffIdArr = []
			const mobile = []
			const paperIdArr = []
			this.disSuccessLoading = true
			for (let i = 0; i < this.distributeMultipleSelection.length; i++) {
				staffIdArr[i] = this.distributeMultipleSelection[i].id
				mobile[i] = this.distributeMultipleSelection[i].mobile
			}
			for (let i in this.multipleSelection) {
				paperIdArr.push(this.multipleSelection[i].id)
			}

			this.$postJson('LecturerPaperStaff/add', {
					paperIdArr: paperIdArr,
					staffIdArr: staffIdArr,
					distribute: this.sysUser,
					limitTime: this.limitDate.getTime(),
					mobile: mobile
				})
				.then(response => {
					this.disSuccessLoading = false
					if (!response.result == '') {
						this.$message.error(response.result) //  重复数据
						this.distributeDialogFormVisible = false
						this.limitTimeHandDialogFormVisible = false
					} else {
						this.distributeDialogFormVisible = false
						this.limitTimeHandDialogFormVisible = false
						this.$message.success('派发成功')
						// this.reload();
						this.selectPaperList()
					}
				})
				.catch(error => {
					this.$message.error(error)
					console.log(error)
				})
		},
		nextStep() {
			this.distributeDialogFormVisible = false
			this.limitTimeHandDialogFormVisible = true
			// console.log(this.distributeMultipleSelection)
		},
		returnStep() {
			this.distributeMultipleSelection = []
			this.distributeDialogFormVisible = true
			this.limitTimeHandDialogFormVisible = false
		},

		/* 派发记录 */
		distributeRecord() {
			this.distributeRecordHandDialogFormVisible = true

			// var params = new URLSearchParams()
			// params.append('distribute', this.$route.query.userid)
			// params.append('pageNo', this.distributeRecordParameter.pageNo)
			// params.append('pageSize', this.distributeRecordParameter.size)
			var params = {
				'ePaperName': this.distributeRecordParameter.ePaperName,
				'sidno': this.distributeRecordParameter.sidno,
				'distribute': this.sysUser,
				'pageNo': this.distributeRecordParameter.pageNo,
				'pageSize': this.distributeRecordParameter.size
			}
			this.$post('Exam_Paper_Staff/selectall', params)
				.then(response => {
					this.disRecordLoading = false
					this.distributeRecordParameter.rows = response.list.rows
					this.distributeRecordParameter.total = response.list.total
					this.distributeRecordParameter.pageNo = response.list.page
					// console.log(response.list)
					// console.log(response.list.page)
				})
				.catch(error => {
					this.$message.error(error)
					console.log(error)
				})
		},
		distributeRecordClear() {
			this.distributeRecordParameter.ePaperName = ''
			this.distributeRecordParameter.sidno = ''
		},
		distributeRecordHandleSelectionChange(val) {
			this.distributeRecordMultipleSelection = val
		},
		distributeRecordHandleCurrentChange(val) {
			this.distributeRecordParameter.pageNo = val
			this.distributeRecord()
		},
		distributeRecordHandleSizeChange(val) {
			this.distributeRecordParameter.size = val
			this.distributeRecord()
		},
		deleteDistributeRecord() {
			this.$confirm('是否删除该记录?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.disRecordLoading = true
				const idArr = []
				for (let i = 0; i < this.distributeRecordMultipleSelection.length; i++) {
					idArr[i] = this.distributeRecordMultipleSelection[i].id
				}
				var param = {
					distribute: this.distributeRecordParameter.distribute,
					idArr: idArr
				}
				this.$postJson('LecturerPaperStaff/del', param)
					.then(response => {
						this.distributeRecordHandDialogFormVisible = false
						this.disRecordLoading = false
						this.$message({
							type: 'success',
							message: '删除成功!'
						})
					})
					.catch(error => {
						console.log(error)
						this.$message.error('删除失败！')
					})
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消删除'
				})
			})
		},

		/* 答题人四种状态颜色 */
		distributeRecordRowClassName({
			row,
			rowIndex
		}) {
			// console.log(row)
			if (row.state == 2 && row.isOver == 2) {
				return 'warning-row'
			} else if (row.state == 2 && row.isOver == 1) {
				return 'success-row'
			} else if (row.state == 1 && row.isOver == 2) {
				return 'error-row'
			}
			return ''
		},

		/* 关联视频 */
		videoHandleSelectionChange(val) {
			this.videoMultipleSelection = val
		},
		videoDialog() {
			this.videoHandDialogFormVisible = true
			this.videoMultipleSelection = ''
			this.video.name = ''
			this.selectVideoList()
		},
		videoClear() {
			this.video.name = ''
			this.video.type = ''
		},
		selectVideoList() {
			/* 分类转换 */
			var videoType = ''
			if (this.video.type != '' && this.video.type != null && this.video.type != undefined) {
				videoType = this.video.type[this.video.type.length - 1]
			}
			this.$get(
					`/trainingVideo?pageNo=${this.video.pageNo}&pageSize=${this.video.size}&name=${this.video.name}&type=${videoType}`
				)
				.then(response => {
					// console.log(response.data);
					this.video.rows = response.list.rows
					this.video.total = response.list.total
					this.video.pageNo = response.list.page
					this.videoLoading = false
				})
				.catch(error => {
					this.$message.error(error)
					console.log(error)
				})
		},
		bindingVideo() {
			const videoIdArr = []
			const paperIdArr = []
			this.videoLoading = true
			for (let i = 0; i < this.videoMultipleSelection.length; i++) {
				videoIdArr[i] = this.videoMultipleSelection[i].id
			}
			for (let i in this.multipleSelection) {
				paperIdArr.push(this.multipleSelection[i].id)
			}

			this.$postJson('LecturerPaperVideo/add', {
					paperIdArr: paperIdArr,
					videoIdArr: videoIdArr,
					staffId: this.sysUser
				})
				.then(response => {
					this.videoLoading = false
					if (!response.result == '') {
						this.$message.error(response.result) //  重复数据
						this.videoHandDialogFormVisible = false
					} else {
						this.videoHandDialogFormVisible = false
						this.$message.success('关联成功')
						// this.reload();
						this.selectPaperList()
					}
				})
				.catch(error => {
					this.$message.error(error)
					console.log(error)
				})
		},
		videoHandleCurrentChange(val) {
			this.video.pageNo = val
			this.selectVideoList()
		},
		videoHandleSizeChange(val) {
			this.video.size = val
			this.selectVideoList()
		},

		/* 关联视频记录 */
		videoRecordDialog() {
			this.videoRecordMultipleSelection = ''
			this.videoRecordHandDialogFormVisible = true
			this.videoRecordLoading = false
			this.selectVideoRecordList()
		},
		selectVideoRecordList(form) {
			this.videoRecordLoading = true
			let params = {
				'name': this.videoRecord.name,
				'paperName': this.videoRecord.paperName,
				'sidno': this.videoRecord.sidno,
				'pageNo': this.videoRecord.pageNo,
				'pageSize': this.videoRecord.size
			}
			this.$post('LecturerPaperVideo/selectall', params)
				.then(response => {
					this.videoRecordLoading = false
					this.videoRecord.rows = response.list.rows
					this.videoRecord.total = response.list.total
					this.videoRecord.pageNo = response.list.page
					// console.log(response.data);
				})
				.catch(error => {
					this.$message.error(error)
					console.log(error)
				})
		},
		videoRecordClear() {
			this.videoRecord.name = ''
			this.videoRecord.paperName = ''
			this.videoRecord.sidno = ''
		},
		delPaperVideo() {
			this.videoRecordLoading = true
			var idArr = []
			for (let i in this.videoRecordMultipleSelection) {
				idArr.push(this.videoRecordMultipleSelection[i].id)
			}
			console.log(idArr)
			this.$postJson('LecturerPaperVideo/del', {
					idArr: idArr
				})
				.then(response => {
					this.videoRecordLoading = false
					this.$message.success("删除成功")
					// console.log(response.data);
					this.videoRecordHandDialogFormVisible = false
				})
				.catch(error => {
					console.log(error)
					this.$message.error("删除失败")
					this.videoRecordHandDialogFormVisible = false
				})
		},
		videoRecordHandleSelectionChange(val) {
			this.videoRecordMultipleSelection = val
		},
		videoRecordHandleCurrentChange(val) {
			this.videoRecord.pageNo = val
			this.selectVideoRecordList()
		},
		videoRecordHandleSizeChange(val) {
			this.videoRecord.size = val
			this.selectVideoRecordList()
		},

	}
}